<template>
  <v-form>
    <v-text-field
      v-model="form.name"
      label="Name"
    />
    <v-checkbox-group
      v-model="checklistItems"
      label="Checklist Items"
    >
      <v-checkbox
        v-for="item in checklistItems"
        :key="item.id"
        :label="item.label"
        :value="item.value"
      />
    </v-checkbox-group>
    <v-btn @click="onSubmit">Submit</v-btn>
  </v-form>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: '',
      },
      checklistItems: [
        { id: 1, label: 'Item 1', value: 'item1' },
        { id: 2, label: 'Item 2', value: 'item2' },
        { id: 3, label: 'Item 3', value: 'item3' },
      ],
    };
  },
  methods: {
    onSubmit() {
      console.log('Submitted!');
    },
  },
};
</script>
